import { Button, Card, CardActions, CardContent, CardHeader } from "@mui/material";
import { ReactNode } from "react";

interface SubscriptionOverviewCardProps {
    title: string;
    children: ReactNode;
    action?: {
        label: string;
        onClick: () => void;
    };
}

const SubscriptionOverviewCard = ({ title, action, children }: SubscriptionOverviewCardProps) => {
    return (
        <Card>
            <CardHeader title={title} />
            <CardContent sx={{ py: 0 }}>{children}</CardContent>
            {action && (
                <CardActions sx={{ justifyContent: "flex-end" }}>
                    <Button variant={"outlined"} onClick={action.onClick} sx={{ textTransform: "none" }}>
                        {action.label}
                    </Button>
                </CardActions>
            )}
        </Card>
    );
};

export default SubscriptionOverviewCard;
